import React from 'react';
import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { Button, Stack } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { Controller, useForm } from 'react-hook-form';
import dayjs, { Dayjs } from 'dayjs';
import { DEFAULT_WHEELS_TIME_FILTERS, WheelsTimeFilters } from '../../../domain/wheels';
import { storeWheelsTimeFiltersInLocalStorage } from '../utils';

export const WheelsTimeFiltersForm = () => {
  const { t } = useTranslation();

  const { control, formState, handleSubmit } = useForm({ defaultValues: DEFAULT_WHEELS_TIME_FILTERS });

  const submitWheelsForm = (timeFilters: WheelsTimeFilters) => {
    storeWheelsTimeFiltersInLocalStorage(timeFilters);

    navigate('/checkout/wheels');
  };

  const handleExitDateChange = (onChange: (date: string) => void) => (date: Dayjs | null) => {
    if (!date) return;
    if (!date.isValid()) return;

    onChange(date.format('YYYY-MM-DD'));
  };

  const handleExitTimeChange = (onChange: (time: string) => void) => (time: Dayjs | null) => {
    if (!time) return;
    if (!time.isValid()) return;

    onChange(time.format('HH:mm'));
  };

  return (
    <>
      <Stack gap={3}>
        <Controller
          control={control}
          name="exitDate"
          rules={{ required: true }}
          render={({ field }) => (
            <DatePicker
              value={field.value ? dayjs(field.value) : null}
              label={t('wheels_service.inputs.exit_date')}
              minDate={dayjs()}
              onChange={handleExitDateChange(field.onChange)}
            />
          )}
        />

        <Controller
          control={control}
          name="exitTime"
          rules={{ required: true }}
          render={({ field }) => (
            <TimePicker
              ampm={false}
              minTime={dayjs(new Date(0, 0, 0, 9))}
              maxTime={dayjs(new Date(0, 0, 0, 23, 30))}
              timeSteps={{ minutes: 30 }}
              value={field.value ? dayjs(field.value, 'HH:mm') : null}
              label={t('wheels_service.inputs.exit_time')}
              onChange={handleExitTimeChange(field.onChange)}
            />
          )}
        />
      </Stack>

      <Stack alignItems="flex-end">
        <Button
          disabled={!formState.isValid}
          size="large"
          variant="contained"
          sx={{ width: 200 }}
          onClick={handleSubmit(submitWheelsForm)}
        >
          {t('wheels_service.form_button')}
        </Button>
      </Stack>
    </>
  );
};
